export default __webpack_public_path__ + "static/media/img_price_zero.460569ce.png";